import { graphql } from '@teachino/shared-infrastructure';

export const addTopicToCourseMutation = graphql(`
  mutation AddTopicToCourse($addTopicsCoursesInput: AddTopicsCoursesInput!) {
    addTopicsToCourses(addTopicsCoursesInput: $addTopicsCoursesInput) {
      done
    }
  }
`);
